import React, { useEffect, useState } from 'react'
import TodayTaskReport from './Components/TodayTaskReport'
import NotAssignedTasks from './Components/NotAssignedTask'
import FollowUp from '../StaffDashboard/FollowUp'
import FinalSubmitTask from '../AdminDashboard/FinalSubmit'
import OnProcessTask from '../AdminDashboard/OnProcess'
import PersonalTask from './Components/PersonalTasks'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import TaskListStatus from './TaskListStatus'
import CustomModal from '../../../components/common/CustomModal'
import { Link } from 'react-router-dom'
import DueTask from './Components/DueTask'
import { ProfileContext } from '../../../context/profile';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react'

const Index = () => {
  const [activeTab, setActiveTab] = useState('taskReport')
  const [taskStatus, setTaskStatus] = useState([])
  const [dueTodayTasks, setDueTodayTasks] = useState([])
  const [openDueModel, setOpenDueModel] = useState(false)
  const [followUpCount, setFollowUpCount] = useState(0)
  const { getProfile } = useContext(ProfileContext);
  const profile = getProfile();
  const navigate = useNavigate();

  const selectedTab = taskStatus?.find((obj) => obj._id === activeTab)

  const fetchTaskStatus = async () => {
    try {
      const response = await axiosAuthInstance.get('task-status/count')
      if (response.status === 200) {
        setTaskStatus(response.data?.result)
      }
    } catch (error) {
      console.error('Error fetching task status', error)
    }
  }
  const fetchFollowUpCount = async () => {
    try {
      const response = await axiosAuthInstance.get('task/list', {
        params: {
          followup: true,
          limit: 100, // adjust as needed
          sortPriority: true,
        },
      });
      const count = response.data?.result?.docs?.length || 0;
      setFollowUpCount(count);
    } catch (error) {
      console.error("Failed to fetch follow-up tasks:", error);
    }
  }

  const fetchDueTodayTasks = async () => {
    try {
      const response = await axiosAuthInstance.get('task/due-today')
      if (response.status === 200) {
        setDueTodayTasks(response.data?.result)
        setOpenDueModel(true)
      }
    } catch (error) {
      console.error('Error fetching due tasks', error)
    }
  }

  const handleTabChange = (tab) => {
    setActiveTab(tab)
  }

  const handleCloseModal = () => {
    setOpenDueModel(false)
  }
  const triggerTaskReminderJob = async () => {
    try {
      if (!profile || !profile._id) return;
      const response = await axiosAuthInstance.get('task/taskreminder');
      const reminders = response.data?.data || [];

      if (response.status === 200 && reminders.length > 0) {
        const MAX_VISIBLE = 3;
        const visibleTasks = reminders.slice(0, MAX_VISIBLE);
        const remainingTasks = reminders.slice(MAX_VISIBLE);

        // ✅ Show up to 3 toasts
        visibleTasks.forEach((task) => {
          toast.custom(
            (t) => (
              <div
                onClick={() => {
                  toast.dismiss(t.id);

                }}
                className={`bg-green-300 p-3 rounded shadow-md cursor-pointer w-80 mb-2 ${t.visible ? 'animate-enter' : 'animate-leave'
                  }`}
              >
                <strong>{task.name}</strong>: This task is still not started.
              </div>
            ),
            { duration: 10000, position: 'bottom-right' }
          );
        });

        // ✅ Show "+N more" summary if needed
        if (remainingTasks.length > 0) {
          toast.custom(
            (t) => (
              <div
                onClick={() => {
                  toast.dismiss(t.id);
                  // Show all remaining toasts in a scrollable list
                  toast.custom(
                    () => (
                      <div className="bg-white max-h-96 overflow-y-auto p-3 rounded shadow-md w-80 space-y-2">
                        {remainingTasks.map((task, idx) => (
                          <div
                            key={idx}

                            className="bg-green-300 p-2 rounded cursor-pointer hover:bg-green-400"
                          >
                            <strong>{task.name}</strong>: This task is still not started.
                          </div>
                        ))}
                        <div
                          onClick={() => toast.dismiss()}
                          className="text-center text-sm text-red-600  mt-3 cursor-pointer hover:underline"
                        >
                          ✖ Close All
                        </div>
                      </div>
                    ),
                    { duration: 10000, position: 'bottom-right' }
                  );
                }}
                className={`bg-yellow-300 p-3 rounded shadow-md cursor-pointer w-80 ${t.visible ? 'animate-enter' : 'animate-leave'
                  }`}
              >
                <strong>+{remainingTasks.length} more</strong> tasks are still not started. Click to view.
              </div>
            ),
            { duration: 10000, position: 'bottom-right' }
          );
        }
      }
    } catch (err) {
      console.error('Failed to trigger task reminder job:', err);
    }
  };

  useEffect(() => {
    fetchTaskStatus()
    fetchDueTodayTasks()
    fetchFollowUpCount();

  }, [])

  useEffect(() => {
    triggerTaskReminderJob();
  }, [profile, navigate]);

  return (
    <>
      {/* Tabs Header */}
      <div className='w-full bg-white p-2 flex gap-4 items-center overflow-x-auto whitespace-nowrap'>
        <TabButton
          label="Task Report"
          active={activeTab === 'taskReport'}
          onClick={() => handleTabChange('taskReport')}
        />
        <TabButton
          label={`Follow Up (${followUpCount})`}
          active={activeTab === 'followUp'}
          onClick={() => handleTabChange('followUp')}
        />
        {taskStatus.map((obj) => (
          <TabButton
            key={obj._id}
            label={`${obj.name} (${obj.total})`}
            active={activeTab === obj._id}
            onClick={() => handleTabChange(obj._id)}
          />
        ))}
      </div>

      {/* Content Sections */}
      {activeTab === 'taskReport' && (
        <div className="p-6 space-y-6 max-w-7xl mx-auto">
          <TodayTaskReport />
          <PersonalTask />
          <DueTask />
          <NotAssignedTasks />
        </div>
      )}

      {activeTab === 'followUp' && (
        <div className="max-w-6xl mx-auto p-6 space-y-8">
          <FollowUp />
        </div>
      )}

      {activeTab === 'onProcess' && (
        <div className="p-6 space-y-6 max-w-7xl mx-auto">
          <OnProcessTask />
        </div>
      )}

      {activeTab === 'completed' && (
        <div className="p-6 space-y-6 max-w-7xl mx-auto">
          <FinalSubmitTask />
        </div>
      )}

      {selectedTab && (
        <TaskListStatus id={selectedTab._id} name={selectedTab.name} />
      )}

      {/* Due Task Modal */}
      {openDueModel && (
        <CustomModal handleCloseModal={handleCloseModal}>
          <div className="p-4 relative">
            <h5 className='m-2 font-bold text-center'>Tasks Due Today</h5>
            <div className="flex flex-col items-center justify-between gap-4">
              <div className="overflow-auto w-full max-h-[300px]">
                <table className="min-w-full table-auto border-collapse">
                  <thead>
                    <tr>
                      <th className="border px-4 py-2 text-left">Task Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dueTodayTasks.map((task) => (
                      <tr key={task._id}>
                        <td className="border px-4 py-2">
                          <Link to={`task/view/${task._id}`}>{task.name}</Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="flex gap-4 mt-4">
                <button
                  onClick={handleCloseModal}
                  className="bg-orange-500 text-white px-4 py-2 rounded"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </CustomModal>
      )}
    </>
  )
}

const TabButton = ({ label, active, onClick }) => (
  <div
    className={`border-1 p-2 rounded-lg text-sm text-gray-600 cursor-pointer hover:bg-orange-100 ${active ? 'bg-orange-100 text-orange-600' : 'hover:text-orange-600'
      }`}
    onClick={onClick}
  >
    <button>{label}</button>
  </div>
)

export default Index
